import React from 'react';

import { useGetPermissions } from 'src/features/auth/api/useGetPermissions';
import { useToken } from 'src/features/auth/api/useToken';
import AuthContext from 'src/features/auth/context/AuthContext';

function AuthProvider({ children }: { children: React.ReactNode }) {
    const { data: tokenData, isPending: isTokenPending } = useToken();

    const { data: permissionData, isLoading: isPermissionsLoading } = useGetPermissions({
        config: { enabled: !!tokenData && !!tokenData.sub },
    });

    const value = React.useMemo(
        () => ({
            permissions: permissionData?.permissions || [],
            permissionsLoaded: !isTokenPending && !isPermissionsLoading,
        }),
        [permissionData?.permissions, isTokenPending, isPermissionsLoading],
    );

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export { AuthProvider };
